module.exports = __webpack_public_path__ + "img/peacejam-banner.fbb6a32c.jpg";